/**
 * Shared label / colour maps used by badges and tables.
 */

import type {
  ConfidenceBand,
  ExceptionSeverity,
  ModelRunStatus,
  StanceLabel,
  ThesisStatus,
} from "./api/types";

export const STANCE_LABELS: Record<StanceLabel, string> = {
  strong_candidate_for_review: "Strong candidate",
  candidate_for_accumulation_review: "Accumulation candidate",
  hold_and_monitor: "Hold and monitor",
  reduce_and_review: "Reduce and review",
  exit_review_candidate: "Exit candidate",
  no_stance: "No stance",
  insufficient_quality: "Insufficient quality",
};

export const STANCE_TONE: Record<StanceLabel, "good" | "ok" | "warn" | "bad" | "muted"> = {
  strong_candidate_for_review: "good",
  candidate_for_accumulation_review: "good",
  hold_and_monitor: "ok",
  reduce_and_review: "warn",
  exit_review_candidate: "bad",
  no_stance: "muted",
  insufficient_quality: "muted",
};

export const CONFIDENCE_TONE: Record<ConfidenceBand, "good" | "ok" | "warn" | "bad" | "muted"> = {
  high: "good",
  medium: "ok",
  low: "warn",
  insufficient: "bad",
};

export const THESIS_TONE: Record<ThesisStatus, "good" | "ok" | "warn" | "bad" | "muted"> = {
  improving: "good",
  stable: "ok",
  deteriorating: "bad",
  unknown: "muted",
};

export const RUN_STATUS_TONE: Record<ModelRunStatus, "good" | "ok" | "warn" | "bad" | "muted"> = {
  succeeded: "good",
  partial: "warn",
  running: "ok",
  pending: "muted",
  failed: "bad",
};

export const EXCEPTION_SEVERITY_TONE: Record<
  ExceptionSeverity,
  "good" | "ok" | "warn" | "bad" | "muted"
> = {
  info: "muted",
  warning: "warn",
  error: "bad",
  critical: "bad",
};

export const NAV_PAGES = [
  { path: "/", label: "Dashboard" },
  { path: "/screener", label: "Screener" },
  { path: "/portfolio", label: "Portfolio" },
  { path: "/policy", label: "Policy" },
  { path: "/audit", label: "Audit" },
] as const;
